/**
 * @typedef {{ balance: string, withdrawableBalance: string, blockedBalance: string, withdrawalFee: string, minWithdrawalBeforeFee: number, withdrawalKycLimit: number }} WithdrawableBalance
 */

import React from "react";
import { useTranslation } from "/utils/hooks/useCustomTranslation";
import { Tooltip } from "/components/core/HeaderNavButtons";
import state from "/redux/state";

/**
 *
 * @param {{ isLoading, data: WithdrawableBalance, error }} param0
 * @returns
 */
export function Balance({ isLoading, data, error }) {
  const { t } = useTranslation();
  if (isLoading && !data) {
    return (
      <BalanceLayout
        data={{
          balance: t("labels.loading"),
          withdrawableBalance: t("labels.loading"),
          blockedBalance: t("labels.loading"),
          withdrawalFee: t("labels.loading"),
          minWithdrawalBeforeFee: t("labels.loading"),
          withdrawalKycLimit: t("labels.loading"),
        }}
      />
    );
  }
  if (error) {
    // handle error
    return (
      <BalanceLayout
        data={{
          balance: "?",
          withdrawableBalance: "?",
          blockedBalance: "?",
          withdrawalFee: "?",
          minWithdrawalBeforeFee: 0,
          withdrawalKycLimit: 0,
        }}
      />
    );
  }
  return <BalanceLayout data={data} />;
}

/**
 *
 * @param {{ data: WithdrawableBalance }} param0
 * @returns
 */
function BalanceLayout({ data }) {
  const isMobile = state.getState().isMobile;
  const { t } = useTranslation();
  return (
    <div className="tico-information df fd-c gap-16">
      <div className="row df jc-sb ai-c gap-10">
        <p className="fixel_14 color-neu">{t("wallet.balance.current")}</p>
        <div className="df ai-c gap-6">
          <p className="fixel_16_sbl">{data.balance}</p>
        </div>
      </div>
      <div className="row df jc-sb ai-c gap-10">
        <p className="fixel_14 color-neu df jc-fs ai-c gap-10">
          <span>{t("wallet.balance.locked")}</span>{" "}
          <Tooltip
            placement="top"
            triggerEventType={isMobile ? "touch" : "hover"}
            triggerContent={
              <span
                className="icon_info"
                style={{ backgroundColor: "#83809c", marginTop: "-4px" }}
              ></span>
            }
          >
            <p style={{ width: "200px" }}>
              {t("wallet.balance.lockedTooltip")}
            </p>
          </Tooltip>
        </p>

        <div className="df ai-c gap-12">
          <p className="fixel_16_sbl">{data.blockedBalance}</p>
        </div>
      </div>

      <div className="row df jc-sb ai-c gap-10">
        <p className="fixel_14 color-neu">{t("wallet.withdraw.serviceFee")}</p>
        <div className="df ai-c gap-6">
          <p className="fixel_16_sbl">{data.withdrawalFee}</p>
        </div>
      </div>

      <div className="full-line"></div>

      <div className="row df jc-sb ai-c gap-10 fixel_22">
        <p>{t("wallet.balance.availableToWithdraw")}</p>
        <div className="df ai-c gap-6">
          <div className="tico_icon"></div>
          <p>{data.withdrawableBalance}</p>
        </div>
      </div>
    </div>
  );
}
